import Set from '@ungap/set';
import { BaseStore } from './BaseStore';

export default class StoreChangeEventHandler {
  private store: BaseStore;

  private getCurrentValueFn: (store: BaseStore) => any;

  private listeners: Set<() => void>;

  private currentValue: any;

  constructor(store: BaseStore, getCurrentValueFn: (store: BaseStore) => any) {
    this.listeners = new Set<() => void>();
    this.store = store;
    this.getCurrentValueFn = getCurrentValueFn;

    this.currentValue = getCurrentValueFn(store);

    this.subscribeToStore();
  }

  private subscribeToStore() {
    this.store.subscribe(() => {
      const newValue = this.getCurrentValueFn(this.store);

      if (newValue !== this.currentValue) {
        this.currentValue = newValue;
        this.callListeners();
      }
    });
  }

  private callListeners() {
    this.listeners.forEach((listener) => listener());
  }

  getCurrentValue() {
    return this.currentValue;
  }

  subscribe(listener: () => void) {
    this.listeners.add(listener);
  }

  unsubscribe(listener: () => void) {
    this.listeners.delete(listener);
  }
}
